import { Button, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from '../../Login/AuthProvider';
import { useChatAuth } from '../Auth/ChatAuthProvider';
import Dashboard from '../DashBoard';
import MenuIcon from '@mui/icons-material/Menu';
import './menu.css';
import menuiconhandle from './menuiconhandle';
const HeaderCom = () => {
  const [isFullscreen, setIsFullscreen] = useState();
  const { isAuthenticated, logout } = useAuth();
  const { ischatAuthenticated, chatlogout } = useChatAuth();
  const loc = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate();
  const onlogout = () => {
    localStorage.removeItem('authToken');
    setAnchorEl(null);
    logout();
  };
  const onchatlogout = () => {
    localStorage.removeItem('adminChatauthToken');
    localStorage.removeItem('chatauthToken');
    setAnchorEl(null);
    chatlogout();
  };
  const location = useLocation();
  return (
    <>
      <div
        className="header"
        style={{
          display: location.pathname.includes('/aichatbot/userchat') || location.pathname.includes('/aichatbot/admin') ? 'none' : 'flex',
          borderBottom: 'solid black 1px',
          paddingBottom: '20px',
          paddingTop: '20px',
          zIndex: 1000,

          // background:
          //   "var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))",
          boxShadow: '0 6px 2px -2px rgba(0, 0, 0, 0.2)',
          // height: '20%',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'fixed',
          left: '0px',
          right: '0px',
          top: '0px'
        }}
      >
        {!loc.pathname.includes('aichatbot') ? (
          <img
            height={30}
            // windth={10}
            alt="logo"
            src="./logo5.gif"
            style={{ float: 'left' }}
          />
        ) : (
          <Typography
            variant="h4"
            color="white"
            sx={{
              float: 'left',
              fontFamily: 'Poppins',
              paddingLeft: '20px',
              fontWeight: 300,
              letterSpacing: 2
            }}
          >
            ChatBot.ai
          </Typography>
        )}
        <div className="non-menu">
          <div style={{ marginRight: '10px' }}>{ischatAuthenticated && loc.pathname.includes('dashboard') ? <Dashboard /> : <></>}</div>
          <div>
            {ischatAuthenticated && loc.pathname.includes('aichatbot') ? (
              <Button
                variant="contained"
                sx={{
                  float: 'right',
                  //backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 70%, #006ce0 100%))',
                  backgroundColor: '#cd143e',
                  marginRight: '10px',
                  '&:hover': {
                    backgroundColor: '#363636',
                    color: 'white'
                  },
                  fontFamily:
                    " system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                }}
                onClick={onchatlogout}
              >
                Logout
              </Button>
            ) : (
              <></>
            )}
          </div>
          <div>
            {isAuthenticated && !loc.pathname.includes('aichatbot') ? (
              <Button
                variant="contained"
                sx={{
                  float: 'right',
                  backgroundColor: '#cd143e',
                  marginRight: '10px',
                  '&:hover': {
                    backgroundColor: '#363636',
                    color: 'white'
                  },
                  fontFamily:
                    " system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                }}
                onClick={onlogout}
              >
                Logout
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="menu-icon-container">
          <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
            <MenuIcon style={{ color: 'white', fontSize: '40px' }} />
          </IconButton>
          <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
            {ischatAuthenticated && loc.pathname.includes('dashboard') && (
              <>
                <MenuItem
                  onClick={() => {
                    navigate('/aichatbot/dashboard');
                    setAnchorEl(null);
                  }}
                >
                  Home
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate('/aichatbot/dashboard/docs');
                    setAnchorEl(null);
                  }}
                >
                  Docs
                </MenuItem>
              </>
            )}

            <div>
              {ischatAuthenticated && loc.pathname.includes('aichatbot') ? (
                <Button
                //  variant="contained"
                // sx={{
                //   float: 'right',
                //   backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 70%, #006ce0 100%))',
                //   marginRight: '10px',
                //   '&:hover': {
                //     backgroundColor: 'rgb(119, 141, 169)',
                //     color: 'rgb(224, 225, 221)'
                //   }
                // }}
                // onClick={onchatlogout}
                >
                  <MenuItem onClick={onchatlogout}>Logout</MenuItem>
                </Button>
              ) : (
                <></>
              )}
            </div>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default HeaderCom;
